<template>
  <div class="space-y-8">
    <!-- <span>测试供货商订单</span> -->
    <div class="flex justify-between items-center head">
      <Option :items="productState" @getOrderList="getOrder" :current_state="current_state"></Option>
      <Search :placeholder="$t('商品名称/订单号')" @search="search"></Search>
    </div>
    <div>

      <Body :data="items" @remove="doOrderList" @cancel="doOrderList" @finish="doOrderList" @send="doSupOrderList"
        @reload="recMoney" @updataPage="updataPage"></Body>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "@vue/composition-api";
import Option from "@/components/mine/order/option.vue";
// import Option from "@/components/supplier/option.vue";
import Search from "@/components/mine/search.vue";
import Body from "/src/components/supplier/orderBody.vue";

export default {
  components: { Option, Search, Body },
  setup(props, ctx) {
    const items = ref();
    const productState = reactive({
      全部订单: "all",
      待付款: "unconfirm",
      待发货: "confirmed",
      已发货: "trading",
      已完成: "finished",
      // 待评价: "uncomment",
      已取消: "canceled",
    });
    //当前状态
    // const current_state = ref(ctx.root.$route.query.q || "unpay");
    const current_state = ref(ctx.root.$route.query.q || "unconfirm");
    //获取订单列表
    const getOrderList = async (val) => {
      ctx.root.$doing()
      const res = await ctx.root.$callapi("sup/getSupOrder", {
        page: 1,
        status: val,
        size: 5,
      });
      ctx.root.$done()
      items.value = res.data;
    };
    const getOrder = (val) => {
      current_state.value = val;
      getOrderList(current_state.value);
    };
    onMounted(() => {
      getOrderList(current_state.value);
    });
    //搜索订单
    const search = async (e) => {
      if (e) {
        await ctx.root
          .$callapi("user/getOrderList", {
            page: 1,
            tag: current_state.value,
            size: 5,
            keyword: e,
          })
          .then((res) => {
            if (res.code === 0) {
              items.value = res.data;
            }
          });
      } else {
        getOrderList(current_state.value);
      }
    };
    //下一页
    const updataPage = async (page) => {
      await ctx.root
        .$callapi("sup/getSupOrder", {
          page: page,
          status: current_state.value,
          size: 5,
        })
        .then((res) => {
          if (res.code === 0) {
            items.value = res.data;
          }
        });
    };
    //供货商订单操作
    const doSupOrderList = async (...args) => {
      // console.log("doSupOrderList:sendgoods")
      const des = {
        send: ctx.root.$t("订单发货成功"),
      };

      await ctx.root
        .$callapi("sup/doSupOrdersAction", {
          action: args[1],
          ids: [args[0]],
        })
        .then((res) => {
          if (res.code === 0) {
            ctx.root.$toast(des[args[1]], "success");
            getOrderList(current_state.value);
          }
        });

    };
    //订单操作
    const recMoney = () => {
      console.log('aaa');
      getOrderList(current_state.value);
    }
    const doOrderList = async (...args) => {
      const des = {
        delete: ctx.root.$t("删除订单成功"),
        cancel: ctx.root.$t("订单取消成功"),
        finish: ctx.root.$t("确认收货成功"),
      };
      await ctx.root
        .$callapi("user/doForOrderAction", {
          action: args[1],
          ids: [args[0]],
        })
        .then((res) => {
          if (res.code === 0) {
            ctx.root.$toast(des[args[1]], "success");
            getOrderList(current_state.value);
          }
        });
    };

    return {
      items,
      search,
      doOrderList,
      productState,
      getOrder,
      current_state,
      updataPage,
      doSupOrderList,
      recMoney
    };
  },
};
</script>

<style lang="scss"></style>